import { type RtkQueryLayers } from '../../core';
import { fronteggUsersApi } from './users.frontegg';

export const fronteggUsersRTKSlice: RtkQueryLayers = {
  reducers: {
    [fronteggUsersApi.reducerPath]: fronteggUsersApi.reducer,
  },
  middlewares: [fronteggUsersApi.middleware],
};
